(function () {
  if (window.DrboVatInfo) {
    window.DrboVatInfo.initAll(document);
    return;
  }

  var rootSelector = '[data-drbo-vat-info]';

  function setStickyLayer(root, isOpen) {
    var stickyNav = root.closest('.drbo-product-sticky-nav');
    if (stickyNav) stickyNav.classList.toggle('is-vat-tooltip-open', isOpen);
  }

  function close(root) {
    var trigger = root.querySelector('[data-drbo-vat-trigger]');
    var tooltip = root.querySelector('[data-drbo-vat-tooltip]');

    root.dataset.vatPinned = 'false';
    root.classList.remove('is-above');
    root.classList.remove('is-open');
    setStickyLayer(root, false);
    trigger.setAttribute('aria-expanded', 'false');
    tooltip.hidden = true;
  }

  function placeTooltip(root, tooltip) {
    var rootRect = root.getBoundingClientRect();
    var tooltipRect = tooltip.getBoundingClientRect();
    var spaceBelow = window.innerHeight - rootRect.bottom;
    var spaceAbove = rootRect.top;
    var shouldOpenAbove = tooltipRect.height + 16 > spaceBelow && spaceAbove > spaceBelow;

    root.classList.toggle('is-above', shouldOpenAbove);
  }

  function closeAll(except) {
    document.querySelectorAll(rootSelector).forEach(function (root) {
      if (root !== except) close(root);
    });
  }

  function open(root, pinned) {
    var trigger = root.querySelector('[data-drbo-vat-trigger]');
    var tooltip = root.querySelector('[data-drbo-vat-tooltip]');

    closeAll(root);
    root.dataset.vatPinned = pinned ? 'true' : 'false';
    root.classList.add('is-open');
    setStickyLayer(root, true);
    trigger.setAttribute('aria-expanded', 'true');
    tooltip.hidden = false;
    placeTooltip(root, tooltip);
  }

  function init(root) {
    if (!root || root.dataset.vatReady === 'true') return;

    var trigger = root.querySelector('[data-drbo-vat-trigger]');
    var tooltip = root.querySelector('[data-drbo-vat-tooltip]');
    if (!trigger || !tooltip) return;

    root.dataset.vatReady = 'true';
    root.dataset.vatPinned = 'false';

    trigger.addEventListener('click', function () {
      if (root.dataset.vatPinned === 'true') {
        close(root);
      } else {
        open(root, true);
      }
    });

    root.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches && root.dataset.vatPinned !== 'true') {
        open(root, false);
      }
    });

    root.addEventListener('mouseleave', function () {
      if (root.dataset.vatPinned !== 'true' && !root.contains(document.activeElement)) {
        close(root);
      }
    });

    trigger.addEventListener('focus', function () {
      if (root.dataset.vatPinned !== 'true') open(root, false);
    });

    trigger.addEventListener('blur', function () {
      window.setTimeout(function () {
        if (root.dataset.vatPinned !== 'true' && !root.contains(document.activeElement)) {
          close(root);
        }
      }, 0);
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest(rootSelector)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.DrboVatInfo = {
    closeAll: closeAll,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
